import { useState } from "react";

export function useTutorial(screenId) {
  const key = `tutorial_seen_${screenId}`;
  const [visible, setVisible] = useState(() => !localStorage.getItem(key));

  const dismiss = () => {
    localStorage.setItem(key, "1");
    setVisible(false);
  };

  const reopen = () => setVisible(true);

  return { visible, dismiss, reopen };
}
